exports.textLabelTileTemplate = {
    $type: "TextLabelTile",
    style: {
        title: {
            show: true,
        },
    },
};
